import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { PayRateSetModel, SetInstructorPayRatesApiCommand } from '@bayclubs/group-classes-employee-api';
import { FormService } from '@bayclubs/utils';

import { Providers } from '../../../interfaces/interfaces.module';
import { InstructorsApiService } from '../../../shared/services/instructors.api.service';
import { ManagementContextResolverService, ProvidersApiService } from '../../../shared/shared.module';
import { ProviderPayratesHistoryComponent } from '../../components/provider-payrates-history/provider-payrates-history.component';
import { ProviderPayratesFormBuilderService } from '../../services/provider-payrates-form-builder.service';

@Component({
    selector: 'app-provider-payrates',
    templateUrl: './provider-payrates.component.html',
    styleUrls: ['./provider-payrates.component.scss'],
    standalone: false
})
export class ProviderPayratesComponent implements OnInit {
    @Input() public provider: Providers.ProviderModel;
    public currentPayRates: PayRateSetModel;

    @ViewChild(ProviderPayratesHistoryComponent) payrateHistory: ProviderPayratesHistoryComponent;

    private providerId: string;

    isEditing = false;
    payRateSetForm: UntypedFormGroup;

    context$ = this.contextResolverService.getContextObservable();

    constructor(
        route: ActivatedRoute,
        private providers: ProvidersApiService,
        private instructors: InstructorsApiService,
        private formBuilder: ProviderPayratesFormBuilderService,
        private contextResolverService: ManagementContextResolverService,
        private router: Router
    ) {
        route.params.subscribe(params => {
            this.providerId = params['id'];
            this.loadProvider();
            this.loadProviderCurrentPayRates();
        });
    }

    ngOnInit() {}

    private loadProviderCurrentPayRates() {
        this.instructors.getCurrentPayRates(this.providerId).subscribe(data => (this.currentPayRates = data));
    }
    private loadProvider() {
        this.providers.get(this.providerId).subscribe(data => {
            this.provider = data;
        });
    }

    get providerHomeClubId(): string {
        if (this.provider && this.provider.approvedProfileData && this.provider.approvedProfileData.homeClub) {
            return this.provider.approvedProfileData.homeClub.id;
        }
    }

    public onEdit() {
        this.initForm();
        this.isEditing = true;
    }

    public onAddCategorySpecificPayRate() {
        this.initForm();
        this.formBuilder.addCategorySpecificPayRate(this.payRateSetForm);
        this.isEditing = true;
    }

    public onCancel() {
        this.discardEditing();
    }

    public onSave() {
        if (this.payRateSetForm) {
            FormService.markFormAsTouched(this.payRateSetForm);
            if (this.payRateSetForm.valid) {
                this.instructors.savePayRates(this.providerId, this.prepareCommand()).subscribe(() => {
                    this.discardEditing();
                    this.refreshData();
                });
            }
        }
    }

    private prepareCommand(): SetInstructorPayRatesApiCommand {
        const apiCommand = {
            validFrom: this.payRateSetForm.get('validFrom').value,
            payRates: this.payRateSetForm.get('payRates').value
        } as SetInstructorPayRatesApiCommand;

        apiCommand.payRates.forEach(payRate => {
            payRate.clubGroupClassCategoryId = payRate['categoryCode']['id'];
            payRate.hourlyRate = FormService.getAmountFromCurrencyMask(payRate.hourlyRate.toString());
        });
        return apiCommand;
    }

    private discardEditing() {
        this.isEditing = false;
        this.payRateSetForm = null;
    }

    private refreshData() {
        this.loadProviderCurrentPayRates();
        this.payrateHistory.refresh();
    }

    private initForm() {
        this.payRateSetForm = this.formBuilder.createForm(this.currentPayRates);
    }

    backToTrainers() {
        this.router.navigate(['/trainers/list']);
    }

    backToTrainerDetails() {
        this.router.navigate([`/trainers/details/${this.providerId}`])
    }
}
